import DashboardPage from './dashboard';
import { Gecko } from '../../Logic';

export default {
    name: 'dashboard',
    url: '/dashboard',
    component: DashboardPage,
    resolve: []
};